export enum LinkTarget {
  BLANK = '_blank',
  SELF = '_self',
  TOP = '_top',
  PARENT = '_parent',
}
